<template>
	<v-menu
		ref="menu"
		v-model="menu"
		:close-on-content-click="false"
		:return-value.sync="dateInner"
		transition="scale-transition"
		offset-y
		max-width="290px"
		min-width="auto"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-text-field
				v-model="dateInner"
				:label="label"
				prepend-icon="mdi-calendar"
				readonly
				v-bind="attrs"
				v-on="on"
			></v-text-field>
		</template>
		<v-date-picker v-model="dateInner" type="month" no-title scrollable>
			<v-spacer></v-spacer>
			<v-btn text color="primary" @click="menu = false">
				Fechar
			</v-btn>
			<v-btn :disabled="dateInner==null" text color="primary" @click="$refs.menu.save(dateInner)">
				Selecionar
			</v-btn>
		</v-date-picker>
	</v-menu>
</template>

<script>
export default {
	props: {
		date: null,
		label: {
			Type: String,
			default: "Selecione"
		}
	},
	data() {
		return {
			dateInner: null,
			menu: false,
			modal: false,
		}
	},
	created() {
		if(this.date!=null){
			let temp = this.date.split("/")
			this.dateInner = temp[1]+'-'+temp[0]
		}
	},
	watch: {
		dateInner(val) {
			if(val!=null){
				this.$emit('newVal', val)
			}
		}
	},
}
</script>
